import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';
import Axios from 'axios';
import swal from 'sweetalert2'

Vue.prototype.$http = Axios;

new Vue({
    el: '#contact-form',
    components: { VueRecaptcha },
    data: {
        'name': '',
        'company': '',
        'email_address': '',
        'telephone': '',
        'message': '',
        'errors': {
            'name': '',
            'company': '',
            'email_address': '',
            'telephone': '',
            'message': ''
        },
        'isProcessing': false
    },
    methods: {
        submitForm(token) {
            this.isProcessing = true;
            this.resetErrors();

            var data = new FormData();
            data.append('name', this.name);
            data.append('company', this.company);
            data.append('email_address', this.email_address);
            data.append('telephone', this.telephone);
            data.append('message', this.message);
            data.append('g-recaptcha-response', token);

            this.$http.post('send.php', data).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
        },

        checkCaptcha(token) {
            this.submitForm(token);
        },

        handleResponse(response) {
            this.isProcessing = false;

            if(response.data.status === 500) {
                this.handleError(response);
            }

            if(response.data.status !== 200) {
                this.errors = response.data.errors;
                this.$children[0].reset();
                return;
            }

            this.clearForm();

            swal({
                title: 'Message sent',
                text: "Your message has been sent. We will respond as soon as we can.",
                type: 'success',
                confirmButtonColor: '#0B6B72'
            });
        },

        handleError(error) {
            console.log(error);

            this.$children[0].reset();

            swal({
                title: 'Error',
                text: "An error occurred while sending your query. Please try again.",
                type: 'error',
                confirmButtonColor: '#0B6B72'
            });

            this.isProcessing = false;
        },

        clearForm() {
            this.name = '';
            this.company = '';
            this.telephone = '';
            this.email_address = '';
            this.message = '';
        },

        resetErrors() {
            this.errors = {
                'name': '',
                'company': '',
                'email_address': '',
                'telephone': '',
                'message': ''
            };
        }
    }
});
